var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-row',[(_vm.data)?_c('b-col',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.data.content)}})]):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }